
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    import {html} from 'lit';
    import {str} from '@lit/localize';

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      'h1fbdfea3ad6d664e': html`Гэта рэалізавана ў рамках праекта
                    <a href="${0}">Folksonomy Engine</a>. Не саромейцеся
                    ўдзельнічаць або пакідаць водгукі.`,
'h5d824b4954e56ea5': html`Scan your <span class="everyday">everyday</span> <span class="foods">foods</span>`,
'h6bdd1b427aa985a4': html`Гэты інструмент дазваляе вам выправіць спіс інгрэдыентаў. Вы можаце дадаваць, выдаляць або рэдагаваць
                спіс інгрэдыентаў.
                <br>
                Гэты сімвал <span class="highlight">␣</span> абазначае прабел.
                <br>
                Гэты сімвал <span class="highlight">↩︎</span> абазначае разрыў радка. `,
'hb28f1f2ec1744ee9': html`Гэтыя ўласцівасці ствараюцца і захоўваюцца карыстальнікамі для любога выкарыстання. Не саромейцеся дадаваць свае ўласныя
                    . Уласцівасці і значэнні, якія вы ствараеце
                    <strong>, павінны быць фактычнымі</strong>. Вы можаце азнаёміцца з
                    <a href="${0}">спісам уласцівасцей, якія ўжо выкарыстоўваюцца супольнасцю</a>
                    або вывучыць дакументацыю па ўласцівасцях
                    <a href="${1}">і яе пошукавую сістэму</a>.`,
's000a5b76bd3a01c2': `Загрузка ўласцівасцей...`,
's000d98595e959c1e': `Get It On Google Play`,
's013bdc8cf0d3583d': `Дапамажыце нам з інгрэдыентамі`,
's01d2865e3e1d5501': `Thank you for your assistance!`,
's02ce7a2e7c1b020b': `Праверце ўраджай`,
's03e9c8114521b998': `Я адрэдагую інгрэдыенты`,
's05ec315d9308091a': `Значок кутоў штрых-кода`,
's061eb5af92512c85': `Захавана! Ці можаце вы дапамагчы з яшчэ адным?`,
's06847c221c4c0bc1': `Я хацеў бы стварыць уласцівасць для [апішыце свой выпадак выкарыстання]...`,
's06f6c6f99db6b552': `Арыгінал`,
's081e2ad82db71e1d': `Згрупаваныя значэнні`,
's09205907b5b56cda': `No`,
's0b4235aae602a950': `спецыяльная дакументацыя`,
's0bb2d48532acc455': `Спампаваць CSV-файл`,
's0d5b7fee0311db68': `Маёмасць`,
's0fb218abc2e157ed': `Ануляваць выяву`,
's100c4928cc74642a': `support the advancement of public health research.`,
's10db5498186c083b': `Адмяніць абрэзку`,
's11a18a69b30b65ed': `Дапамажыце нам выправіць памылкі ў спісе інгрэдыентаў`,
's1205d5f6fccf8e69': `Кошт нерухомасці`,
's15d64a0a6715285a': `Новы ключ`,
's166bd56d19670a72': `Маштаб`,
's19059bf0c4f7c162': `Вобласць выбару`,
's1a52515ec8ddade8': `Product barcode`,
's1c5031113de500ce': `keeping our database open &amp; available to all,`,
's1dc4daf989c71284': `Дапамажыце нам выправіць інфармацыю пра харчовую каштоўнасць`,
's1e00019dc454872d': `Калі ласка, укажыце назву ўласцівасці, выкарыстоўваючы атрыбут property-name.`,
's1e49126af0935a5b': `Спіс прадуктаў, якія выкарыстоўваюць гэтую ўласцівасць`,
's21e73088de6f26f3': `Download on the App Store`,
's255857544a9d5ec0': `Reset`,
's25e94495991e95ba': `Thanks for your help! Can you assist with another question?`,
's2ceb11be2290bb1b': `Cancel`,
's2db7b654c0a9bde0': `Дакументуйце маёмасць`,
's300b3a6ee4e1252d': str`Дрэннае супадзенне ${0}%`,
's33f786bb6b4f0cf4': `Вынік абрэзкі`,
's33f85f24c0f5f008': `Save`,
's34be4af4e8fec4ae': `Спачатку спытайце ў супольнасці`,
's36d86adc823cbfa6': `Перад стварэннем новай нерухомасці абмяркуйце яе з супольнасцю:`,
's3781d25aa51a736c': `Дакументацыя па рухавіку Folksonomy`,
's383ae4449428b61e': `Скінуць абрэзку`,
's39bcf88721a1e8ee': `Скінуць выбар`,
's39e14e14300694c7': `Дакументацыя і рэкамендацыі`,
's3b430cfa5c1fe7f4': str`Дакументацыя для ${0}`,
's3f4e4b52f230a892': `Палатно выявы`,
's417b90913e05bc17': `Папярэдні прагляд`,
's41f7dca46d3f1b4a': `Value`,
's422bba9636ce2489': `Цэнтраваць выяву`,
's42dd66b2441566fd': `Значок цэнтра`,
's43df2e8395f6834e': str`Please give to our ${0} Fundraiser`,
's453188ea728f64da': `Дадайце пажыўнае рэчыва`,
's453ab0dbb9b5c777': `Змяніць памер справа`,
's475b08749d0706ed': `Help us inform millions of consumers around the world about what they eat`,
's49730f3d5751a433': `Загрузка...`,
's4bbc7472834a9686': `Your browser does not support barcode scanning.`,
's4d42cc7e00076a3b': `Колькасць прадуктаў`,
's4df2f533c0c1e7d0': `Элементы кіравання выявамі`,
's4e94adf723979402': `Open Food Facts needs your help with this product.`,
's4f4886341969d552': `Перамясціць вылучэнне`,
's4f751fb9b3ed766c': `Стварэнне новай нерухомасці`,
's547c12ae169d00bc': `Available on F-Droid`,
's5560fb119e40923d': `Увядзіце назву ўласцівасці...`,
's55d7249883a98ca1': `пра гэтую нерухомасць на вікі Open Food Facts`,
's565867d84c04aea2': `Уласцівасці фільтра...`,
's5666afe5cd0166de': `Калі ласка, выпраўце памылкі або змяніце тэкст перад пацвярджэннем`,
's57472465a23b41db': `Values`,
's58e1eeea7a60ae51': `Загрузка прадуктаў...`,
's59df20feee978e5b': `Error: Invalid value.`,
's5c92c0051d44b6de': `Дапамажыце нам выправіць інфармацыю аб харчовай каштоўнасці.`,
's5dd6f12783fca34f': `Рэдагаваць спіс інгрэдыентаў`,
's5e8250fb85d64c23': `Close`,
's5ed03bb1f3a15949': `Picture`,
's6306a31415aea913': `I SUPPORT`,
's6498dfe4855bb3a7': `unit`,
's64ef2a6c2dd1d3d1': `Edit`,
's66413c24dcf680e2': `Skip`,
's67ae6594857a4d57': `Дзякуй за ваш унёсак!`,
's6cee7cad81dfedd1': `Абрэзаная выява`,
's6d7b6cdedaadfb6e': `Each donation counts! We appreciate your support in bringing further food transparency in the world.`,
's7124dde792a8faa2': `Android APK`,
's718dea04853f80ae': str`Добрае супадзенне ${0}%`,
's71a5c9f4b68ef4d4': `Колькасьць`,
's74cb3d66f6a668e1': `Дакументацыя`,
's787dd11bed0dc88a': `Змяніць памер злева`,
's7ce4fd9430e80cea': `value`,
's801a05fa8e881f37': `Даведайцеся больш пра стварэнне нерухомасці і рэкамендацыі:`,
's8038273de2cf8b73': `Калі ласка, выберыце вобласць для абрэзкі.`,
's839cc2908a5387f2': `Фільтраваць штрых-коды...`,
's86197dcf3e96af64': `Прагляд і пошук існуючых аб'ектаў нерухомасці`,
's8a63be30a129a59c': `Змяніць памер ніжняй часткі`,
's8a8bfd67f2dd2810': `Download the OFF app with this QR code`,
's8af61807443f32a4': `Actions`,
's8b33c244759d7bd4': `Змяніць памер уверсе справа`,
's8db84aa4bc949af2': `Дакументуйце новую нерухомасць`,
's8f839a03997a16d7': `Праглядзець прадукт`,
's901ae1e236ac45d3': `Адмяніць выдаленне`,
's907f7a97c6b29425': `Майце на ўвазе, што мадэль дадзеных можа быць зменена. Выкарыстоўвайце на свой страх і рызыку.`,
's95d23d03f9147581': `Unzoom`,
's976dfd19ef58a1e1': `Click to scan a barcode and find out its details (health, preferences, etc.)`,
's98ff35f2a00dc60d': `Інгрэдыенты:`,
's9a7f60fce090ecaf': `Не атрымалася загрузіць уласцівасці. Паўтарыце спробу пазней.`,
's9b87abd68fb9df45': `Не знайшлі? Стварыце новы ключ {value}`,
's9c0f52425fd2f07e': `Можа не супадаць`,
's9fc41f789c63b40d': `Прадукты`,
'sa1fa766e0d5634d7': `Няма ацэнак`,
'sa548778b24054030': `Азнаёмцеся з усімі ўласцівасцямі, атрыманымі ў рамках праекта Folksonomy Engine. Гэтыя ўласцівасці забяспечваюць дадатковыя метададзеныя і інфармацыю аб прадуктах у базе дадзеных Open Food Facts.`,
'sa63907958bd0ec4b': `Змяніць памер верхняга левага акна`,
'sa95b4224f685a36a': `Закрыць мадальнае акно`,
'sab56a1d439576fd6': `Значок прапановы`,
'sac47ea2901d04c15': `Змяніць памер ніжняга левага акна`,
'sb125227d436c2925': `Знайдзіце сваю канцэпцыю нерухомасці ў існуючай базе дадзеных нерухомасці:`,
'sb125568d43642e6f': `Адказвайце на пытанні аб прадукце.`,
'sb1c538e038f9b214': str`Вельмі добрае супадзенне ${0}%`,
'sb28639570ff3b852': `спіс усіх аб'ектаў нерухомасці`,
'sb3bdd638a58d30f4': `engage a community of committed citizens,`,
'sb3cbcc1bd0fff140': `Пасля таго, як вы пераканаецеся, што вашай уласнасці не існуе, і супольнасць пагодзіцца з яе карыснасцю, вам спачатку трэба задакументаваць яе ў вікі.`,
'sb3d4f79d9d8b71e5': `Пацьвердзіць`,
'sb560fa37a7bfb6c2': `Для гэтай нерухомасці тавараў не знойдзена.`,
'sb7f72e4c8a2d3357': `Фільтраваць значэнні...`,
'sb8178320160f84ea': `Паказаць абрэзку`,
'sbad7d2734149470b': `Праверыць`,
'sbb623d6b18d966a0': `Nutrition facts are displayed on the packaging:`,
'sbd6be5cde472f37c': `На ўсе пытанні дадзены адказы! Дзякуй за дапамогу!`,
'sbd9a0b2293b3cd3c': `Памер порцыі`,
'sbe472dc3c2685985': `Адпаведнае значэнне`,
'sc0520e1732a5c568': `Expand image`,
'sc0cc559e7ede852a': `Змяніць памер верхняй часткі`,
'sc1c08d0cbcc3bd24': `Не супадае`,
'sc52696641af72b53': `Install the app!`,
'sc5575e3107f87874': `Rotate image to the left`,
'sc57b630a7a70c61f': `Прапанаванае выпраўленне`,
'sc681b137e8f604f7': `Пацвердзіць выдаленне`,
'sc6daf8a31883f8b9': `Перамясціць выяву`,
'sc895972c88d38ca5': `Уласнасць фолксаноміі`,
'sca0c3305aff570b8': str`per specified serving "${0}"`,
'scace072bef961918': `Радкі`,
'scb3b0671d7b7f640': `Новае значэнне`,
'scb489a1a173ac3f0': `Yes`,
'scbab4bd737ba7934': str`group photo donation ${0}`,
'scd21019c3cd618f3': `Далучайцеся да абмеркавання ў Slack`,
'scdb6cad0b92721bf': `Уласцівасці не знойдзены.`,
'scf23a05631f93732': `Пацвердзіць выдаленне`,
'scfed2f270ef6a3aa': `Выберыце вобласць`,
'sd1022bc1ef9204f7': `Маштабуемая выява`,
'sd1077c055cf9ba6b': `Дапамажыце нам праверыць спіс інгрэдыентаў прадукту.`,
'sd698d21ddecba56b': `Гэй! Вы можаце дапамагчы нам палепшыць інфармацыю пра прадукт, адказаўшы на наступныя пытанні:`,
'sd82bc2decefa621b': `remain independent of the food industry,`,
'sdb97e5976482606e': `Праверце, ці ўжо існуе ўласцівасць`,
'sdbf806fefc584115': `Вам варта знайсці`,
'sdc673e73b5c13aea': `Выдаліць`,
'sdc792b75f1edcaba': `Дапамажыце нам выправіць правапіс інгрэдыентаў.`,
'sdca5deead576ceee': `Змяніць памер унізе справа`,
'sdcc2555c5dde524f': `Вы ўпэўненыя, што хочаце выдаліць гэты элемент? Гэта дзеянне нельга адмяніць.`,
'se206feec7ec57b28': `на 100 г`,
'se419a9ab36987490': `Ануляваць`,
'se5127cf0f92e7e48': `Парада: вы таксама можаце знайсці`,
'se773f50d2a16d481': `Rotate image to the right`,
'sebb2c6c830a44574': `technical infrastructure (website/mobile app) &amp; a small permanent team`,
'sec6377f3c4e9b28c': `Я прапаную лепшы ўраджай`,
'seea3800e27baa686': `Асобныя прадукты`,
'sefaba4adc4ec9219': `Уласцівасці Фолксаноміі`,
'seffa8ca49175b5f0': `Персаналізаваныя ўласцівасці`,
'sf44a6b3b232c28ea': str`Замяніць бягучае значэнне на ${0}`,
'sf4cd86a2f5ef2588': `Штрых-код прадукту`,
'sf57a61152168cc81': `Дапамажыце нам выправіць выяўленне інгрэдыентаў`,
'sf88b90b8ba23871c': `Невядомае супадзенне`,
'sf9aee319a006c9b4': `Дадаць`,
'sfacbbe968fa7d773': `Назва нерухомасці:`,
'sfc40ea3d5d5aa6f8': `Your donations fund the day-to-day operations of our non-profit association:`,
'sfe87465d50530725': `Адпаведнае значэнне`,
's5f343a43e7ea9f91': `Error`,
'sd947a599045e9e0e': `Failed to check property conflicts. Please try again.`,
's92a0d19a28995530': `Success`,
's371091f240c17a7e': `Property renamed successfully!`,
's4603f58131a777bf': `Failed to rename property. Please try again.`,
's21694d2ab9c0bec5': `Property deleted successfully!`,
'scf78b75273a6b5fe': `Failed to delete property. Please try again.`,
's71ffcb25fc1c5356': `Rename this property`,
's60320a18282b2b33': `Rename`,
's6e2a82009cc3dfc7': `Delete this property`,
's8bccacf0fc176064': `Rename Property`,
's0df37909a355e56f': str`Rename property '${0}' to:`,
'sb550440eeb3f39c5': `New property name:`,
'sbb53591e587764b7': `Enter new property name...`,
's8acd49e96b4ee7d4': `Check Conflicts`,
'sd1cfdf0ef29cb6a5': `Property Rename Conflicts`,
'sf417737adaa5a8c2': str`Renaming '${0}' to '${1}' will affect:`,
's14571d0ac58a8b43': `Products with both properties:`,
'sb0d459e32656033f': `Products with old property only:`,
'sfa3027dde47305fe': `Products with new property only:`,
's9e5b8feb0892646e': `Do you want to proceed with the rename?`,
's97171907a2d1620b': `Proceed with Rename`,
's712d70fdcc3dd42b': `Delete Property`,
'sc11b78f2f3173f75': str`Are you sure you want to delete the property '${0}'?`,
's3b3fe4e829af3e8e': `This action cannot be undone.`,
's091d3d07b5b3076f': `OK`,
's72c9c4e6ab4ca7ae': `Value replaced successfully!`,
'sdd0eacd725bb2b1d': `Failed to replace value. Please try again.`,
'sfe87a7a8bed11acf': `Value deleted successfully!`,
'sccd2745bdd1087f6': `Failed to delete value. Please try again.`,
's88ece9a678e2f106': `Replace Value`,
's3355d65e22e222c9': str`Replace all instances of '${0}' with a new value:`,
's0d426d718d97d14e': `New value:`,
'se80a1ed3dcab7408': `Enter new value...`,
's2a8434b16dc214a3': `Replace`,
's8263352c7a634e7f': `Delete Value`,
'sebe99e3299746177': str`Are you sure you want to delete all instances of the value '${0}'?`,
's4b0b53abbd6af54a': `Replace this value across all products`,
'sb02836b5e3176cfe': `Delete this value from all products`,
    };
  